module.exports = __webpack_public_path__ + "img/fig11.f690ea2f.jpg";